export default __webpack_public_path__ + "static/media/ahrayot-mission.92c1adcb.png";